import React from 'react';
import '../../styles/components/ModalDownloadTable.scss';
import { SubManager } from '../../classes/SubManager';
import { Button, Loading } from '../Carbon';
import { AsperaWrapper } from '../AsperaWrapper';
import { language } from '../../services/LanguageService';
import { AsperaError } from '../../classes/AsperaError';
import { saveFile, getPageBaseAllApiCall, getOffsetBaseAllApiCall } from '../../helpers/starterHelpers';
/**
 * React component
 *
 * View for downloading the full table
 */
export class ModalDownloadTable extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: false,
            loading: true,
        };
        this.subManager = new SubManager();
        this.data = [];
        this.download = () => {
            const { tableData } = this.props;
            saveFile(this.data.join('\n'), 'text/plain', `${tableData.tableId}.csv`);
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.setData = (data) => {
            const { tableData, rawData } = this.props;
            const allowTypes = ['string', 'number', 'boolean', 'bigint'];
            this.data = [];
            if (tableData.alterDataStore) {
                data = tableData.alterDataStore(data);
            }
            if (rawData) {
                const keys = Object.keys(data[0] || {});
                this.data.push(keys.map(row => row.trim().replace(/\r\n|\n|\r/gm, ' ').replace(/,/g, '_')).join(','));
                data.forEach(item => {
                    const rowData = keys.map(key => {
                        const finalItem = item[key];
                        if (!finalItem) {
                            return '';
                        }
                        else if (typeof finalItem === 'object') {
                            try {
                                return JSON.stringify(finalItem);
                            }
                            catch (error) {
                                new AsperaError('ModalDownloadTable: unable to stringify object', error);
                                return '';
                            }
                        }
                        else if (allowTypes.includes(typeof finalItem)) {
                            return String(finalItem);
                        }
                        else {
                            return '';
                        }
                    });
                    this.data.push(rowData.map(row => row.trim().replace(/\r\n|\n|\r/gm, ' ').replace(/,/g, '_')).join(','));
                });
            }
            else {
                const headers = [];
                tableData.headerData.filter(item => item.type === 'text').forEach(item => {
                    headers.push(`${item.name} (${item.key})`);
                    if (item.secondaryKey) {
                        headers.push(`${item.name} (${item.secondaryKey})`);
                    }
                });
                this.data.push(headers.map(row => row.trim().replace(/\r\n|\n|\r/gm, ' ').replace(/,/g, '_')).join(','));
                data.forEach(item => {
                    const rowData = [];
                    tableData.headerData.filter(item => item.type === 'text').forEach(header => {
                        let mainKey = item[header.key];
                        if (header.key.indexOf('.') > -1) {
                            const keys = header.key.split('.');
                            if (keys[0] && keys[1] && typeof item[keys[0]] === 'object') {
                                mainKey = item[keys[0]][keys[1]];
                            }
                        }
                        const mainItem = header.formatter ? header.formatter(mainKey, item) : mainKey;
                        if (allowTypes.includes(typeof mainItem)) {
                            rowData.push(String(mainItem));
                        }
                        else {
                            rowData.push('');
                        }
                        if (header.secondaryKey) {
                            let secondaryKey = item[header.secondaryKey];
                            if (header.secondaryKey.indexOf('.') > -1) {
                                const secondKeys = header.secondaryKey.split('.');
                                if (secondKeys[0] && secondKeys[1] && typeof item[secondKeys[0]] === 'object') {
                                    secondaryKey = item[secondKeys[0]][secondKeys[1]];
                                }
                            }
                            const secondItem = header.secondaryFormatter ? header.secondaryFormatter(secondaryKey, item) : secondaryKey;
                            if (allowTypes.includes(typeof secondItem)) {
                                rowData.push(String(secondItem));
                            }
                            else {
                                rowData.push('');
                            }
                        }
                    });
                    this.data.push(rowData.map(row => row.trim().replace(/\r\n|\n|\r/gm, ' ').replace(/,/g, '_')).join(','));
                });
            }
            this.setState({ loading: false });
        };
    }
    get loadingView() {
        return (React.createElement("div", { className: "download-table--loading" },
            React.createElement("div", { className: "download-table--info" }, language.get('downloadAsCsv.downloadWorking')),
            React.createElement(Loading, { description: language.get('pageSystem.loading'), withOverlay: false, className: "center-loading" })));
    }
    get downloadView() {
        return (React.createElement("div", { className: "download-table--ready" },
            React.createElement("div", { className: "download-table--info" }, language.get('downloadAsCsv.downloadReady')),
            React.createElement(Button, { onClick: this.download }, language.get('downloadAsCsv.download'))));
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        this.subManager.unsubscribeAll();
        modalClose({});
    }
    componentDidMount() {
        const { tableData } = this.props;
        if (tableData.apiData) {
            let apiCall = getPageBaseAllApiCall(tableData.apiData);
            if (tableData.nextPagingKey) {
                apiCall = getOffsetBaseAllApiCall(tableData.apiData, tableData.nextPagingKey);
            }
            this.subManager.setSubscription(apiCall.subscribe({
                next: items => {
                    this.setData(items);
                },
                error: error => {
                    new AsperaError('ModalDownloadTable: unable to get all rows', error);
                    this.setState({ loading: false, error: true });
                },
            }));
        }
        else if (tableData.staticRowData) {
            this.setData(tableData.staticRowData);
        }
        else {
            this.setState({ loading: false, error: true });
        }
    }
    render() {
        const { loading, error } = this.state;
        return (React.createElement(AsperaWrapper, { error: error, className: "modal-download-table" }, loading ? this.loadingView : this.downloadView));
    }
}
export default ModalDownloadTable;
